<template>
  <div v-if="label" class="tag">{{ label }}</div>
</template>
<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    record?: any
  }>(),
  {
    record: () => ({}),
  }
)
const { $t } = useNuxtApp()

const NAME_MAP: any = {
  [COLLECTION_MAP.OPUS]: $t('zuo-pin'),
  [COLLECTION_MAP.PIECES]: $t('cheng-pian'),
  [COLLECTION_MAP.PIECES_TEMPLATE]: $t('cheng-pian-mo-ban'),
}

const label = computed(() => {
  if (
    [
      COLLECTION_MAP.OPUS,
      COLLECTION_MAP.PIECES,
      COLLECTION_MAP.PIECES_TEMPLATE,
    ].includes(props?.record?.model_type)
  ) {
    return NAME_MAP[props?.record?.model_type]
  }

  if (props?.record?.model_type === COLLECTION_MAP.SOURCE) {
    return RESOURCE_TYPE_MAP()[props?.record?.resource_type]
  }

  return ''
})
</script>
<style lang="scss" scoped>
.tag {
  @apply bg-back-1 rounded-md opacity-90 p-[2px_6px] text-[11px] leading-[16px] text-primary font-medium;
  backdrop-filter: blur(2px);
}
</style>
